module.exports = __webpack_public_path__ + "img/notes-white.940abf21.svg";